import { useState, useRef, useEffect, useCallback } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback((e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  const handleSelect = (url: string) => {
    setOpen(false);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-2.5 bg-white/90 backdrop-blur-sm border border-white/30 rounded-full text-sm text-foreground-800 hover:bg-white cursor-pointer whitespace-nowrap transition-all duration-200"
      >
        <span>Select Category</span>
        <span className="w-4 h-4 flex items-center justify-center">
          {open ? (
            <i className="ri-arrow-up-s-line text-base"></i>
          ) : (
            <i className="ri-arrow-down-s-line text-base"></i>
          )}
        </span>
      </button>

      {open && (
        <div className="absolute top-full mt-2 right-0 w-64 bg-white rounded-2xl overflow-hidden z-50 max-h-[420px] overflow-y-auto">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => handleSelect(cat.url)}
              className="w-full text-left px-5 py-3 text-sm text-foreground-800 hover:bg-accent-50 hover:text-accent-700 transition-colors duration-150 cursor-pointer whitespace-nowrap border-b border-background-100 last:border-b-0 flex items-center justify-between group"
            >
              <span>{cat.name}</span>
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-external-link-line text-xs text-foreground-300 group-hover:text-accent-500 transition-colors"></i>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}